import { Select, Space } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { usePermission } from "@/shared/hooks/usePermission";
import { useRetryScheduledTask, useScheduledTasks } from "../hooks/useJobs";
import type { ScheduledTaskFilterState, ScheduledTaskStatus } from "../types";
import { VAZIFA_HOLATLARI, VAZIFA_TURLARI } from "../utils/tasks";
import { ScheduledTasksTable } from "./ScheduledTasksTable";

/**
 * Rejali vazifalar tabi — filtr va jadval.
 *
 * ⚠️ Holat filtri `scheduled_task_status` enumidan quriladi. Reja matni
 * `failed` holatini nazarda tutgan edi, lekin enumda bunday qiymat YO'Q:
 * yiqilgan vazifa `cancelled` + `last_error` bo'lib yoziladi va
 * `status=failed` so'rovi 400 bilan rad etilardi.
 */
export function ScheduledTasksPanel() {
	const { t } = useTranslation("jobs");
	const [filters, setFilters] = useState<ScheduledTaskFilterState>({});
	const query = useScheduledTasks(filters);
	const { can } = usePermission();
	const retry = useRetryScheduledTask();

	return (
		<>
			<Space wrap className="mb-4">
				<Select
					allowClear
					placeholder={t("scheduledTasks.filters.kindPlaceholder")}
					style={{ width: 200 }}
					options={VAZIFA_TURLARI.map((tur) => ({ value: tur, label: tur }))}
					value={filters.kind}
					onChange={(kind) => {
						setFilters({ ...filters, kind });
						query.setPage(1);
					}}
				/>
				<Select
					allowClear
					placeholder={t("scheduledTasks.filters.statusPlaceholder")}
					style={{ width: 200 }}
					options={VAZIFA_HOLATLARI.map((holat) => ({
						value: holat,
						label: t(`scheduledTasks.status.${holat}`),
					}))}
					value={filters.status}
					onChange={(status: ScheduledTaskStatus | undefined) => {
						setFilters({ ...filters, status });
						query.setPage(1);
					}}
				/>
			</Space>

			<ScheduledTasksTable
				query={query}
				canRetry={can("jobs", "retry")}
				retryingId={retry.isPending ? (retry.variables ?? null) : null}
				onRetry={(task) => retry.mutate(task.id)}
			/>
		</>
	);
}
